import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { Utensils, Waves, Footprints, Bike, Landmark, FerrisWheel, BedDouble, MapPin } from 'lucide-react';

export const TRAIL_KEYS = { 'Sendero': 'senderos', 'Bicicletas y caballos': 'bicicleta', 'Vehículos a motor': 'pistas' };

export const TYPOLOGIES = [
  { key: 'eat', color: '#E07A3F', icon: Utensils, categories: ['restaurants', 'guachinches', 'gastronomy', 'wineries', 'local-products'], trailKeys: [], label: { es: 'Comer', en: 'Eat', de: 'Essen' } },
  { key: 'swim', color: '#0E9BC2', icon: Waves, categories: ['beaches', 'natural-pools'], trailKeys: [], label: { es: 'Nadar', en: 'Swim', de: 'Baden' } },
  { key: 'walk', color: '#2F9E5B', icon: Footprints, categories: ['hiking', 'natural-parks', 'viewpoints'], trailKeys: ['senderos'], label: { es: 'Caminar', en: 'Walk', de: 'Wandern' } },
  { key: 'bike', color: '#2B4C9B', icon: Bike, categories: [], trailKeys: ['bicicleta', 'pistas'], label: { es: 'Bici', en: 'Bike', de: 'Rad' } },
  { key: 'culture', color: '#B7791F', icon: Landmark, categories: ['museums', 'cities'], trailKeys: [], label: { es: 'Cultura', en: 'Culture', de: 'Kultur' } },
  { key: 'fun', color: '#D64545', icon: FerrisWheel, categories: ['theme-parks'], trailKeys: [], label: { es: 'Familia', en: 'Family', de: 'Familie' } },
  { key: 'sleep', color: '#6B5B95', icon: BedDouble, categories: ['apartments'], trailKeys: [], label: { es: 'Dormir', en: 'Sleep', de: 'Schlafen' } },
];

export const OTHER_TYPOLOGY = { key: 'other', color: '#006D77', icon: MapPin, categories: [], trailKeys: [], label: { es: 'Otros', en: 'Other', de: 'Sonstiges' } };

const MAPPED = new Set(TYPOLOGIES.flatMap(t => t.categories));
export const isMappedCategory = (slug) => MAPPED.has(slug);

export const typologyForCategory = (slug) => TYPOLOGIES.find(t => t.categories.includes(slug)) || OTHER_TYPOLOGY;

export const typologyForTrail = (trail) => (TRAIL_KEYS[trail.trail_class] === 'senderos' ? TYPOLOGIES[2] : TYPOLOGIES[3]);

export const placeCategories = (p) => (p.categories?.length ? p.categories : [p.category]);

// First category of the place that is enabled decides its typology (primary first)
export const typologyForPlace = (place, enabled) => {
  const cats = placeCategories(place);
  const pick = enabled ? cats.find(c => enabled[c]) : cats[0];
  return typologyForCategory(pick ?? cats[0]);
};

const svgCache = {};
const dataUrl = (svg) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
const iconMarkup = (Icon, size, x, y, color = '#fff', stroke = 2.4) =>
  renderToStaticMarkup(<Icon size={size} color={color} strokeWidth={stroke} x={x} y={y} />);

export const pinIconUrl = (t, variant = 'place') => {
  const k = `pin-${t.key}-${variant}`;
  if (svgCache[k]) return svgCache[k];
  const shape = variant === 'trail'
    ? 'M4 0h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4h-6l-2 8-2-8H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z'
    : 'M12 0C5.4 0 0 5.4 0 12c0 9 12 20 12 20s12-11 12-20C24 5.4 18.6 0 12 0z';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="48" viewBox="-1 -1 26 34"><path d="${shape}" fill="${t.color}" stroke="#fff" stroke-width="1.5"/>${iconMarkup(t.icon, 12, 6, 6)}</svg>`;
  svgCache[k] = dataUrl(svg);
  return svgCache[k];
};

export const clusterIconUrl = (t) => {
  const k = `cluster-${t.key}`;
  if (svgCache[k]) return svgCache[k];
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="62" height="34" viewBox="0 0 62 34"><rect x="1" y="1" width="60" height="32" rx="16" fill="${t.color}" stroke="#fff" stroke-width="2"/><circle cx="17" cy="17" r="12" fill="rgba(255,255,255,0.22)"/>${iconMarkup(t.icon, 14, 10, 10)}</svg>`;
  svgCache[k] = dataUrl(svg);
  return svgCache[k];
};

export const clusterStyle = (t) => ({
  url: clusterIconUrl(t), width: 62, height: 34, textColor: '#ffffff', textSize: 13, fontWeight: '700', fontFamily: 'inherit', anchorText: [0, 11],
});
